import React from 'react';
import { ResponsiveContext, Box, Text } from 'grommet';

const TitleSideBar = ({ value }) => {
  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Box>
          <Text
            size={ size === 'small' ? 'large' : 'xlarge' }
            textAlign='start'
          >
            {value}
          </Text>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  )
}

export default TitleSideBar;
